var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6221 11.3211L11.0861 9.11942C10.9771 9.04438 10.8513 9.00315 10.7222 9.00017C10.5931 8.9972 10.4658 9.03259 10.354 9.10254C10.2421 9.17248 10.1501 9.2743 10.0878 9.39695C10.0255 9.51961 9.99533 9.65842 10.0006 9.79834V14.2017C9.99533 14.3416 10.0255 14.4804 10.0878 14.603C10.1501 14.7257 10.2421 14.8275 10.354 14.8974C10.4658 14.9674 10.5931 15.0028 10.7222 14.9998C10.8513 14.9969 10.9771 14.9556 11.0861 14.8806L14.6221 12.6789C14.7361 12.6138 14.8316 12.5162 14.8982 12.3965C14.9648 12.2769 15 12.1398 15 12C15 11.8602 14.9648 11.7231 14.8982 11.6035C14.8316 11.4838 14.7361 11.3862 14.6221 11.3211Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.0be3085f.svg";
export { ForwardRef as ReactComponent };